"use strict";

/*
 * CPM Auth NPM Package
 * Copyright (C) 2023 CPM
 *
 * All rights reserved.
 *
 * This software and its documentation are considered to be the Confidential and Proprietary Information of
 * CPM. Any use, copying, reproduction, modification, distribution, or disclosure directly
 * or indirectly, in whole or in part, including in derivative works, is prohibited without the express written
 * consent of CPM.
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerRefreshInterceptor = void 0;
const cookie_lock_1 = require("./cookie-lock");
const utils_1 = require("./utils");
/**
 * Registers a request interceptor that will queue requests until a valid access token is available.
 * @param axiosInst - An Axios Instance
 * @param callback - Called after a valid access token is obtained but before the request is made.  Can be used to modify the request to add a bearer token or other changes.
 */
const registerRefreshInterceptor = _ref => {
  let {
    axiosInst,
    ssoUrl,
    callback,
    redirect
  } = _ref;
  //  Check Session Type
  const sessionType = (0, utils_1.getSessionType)();
  //  Skip for Basic Sessions
  if (sessionType === "basic") {
    console.log("Not registering refresh interceptor for non refresh enabled user. (no csrf token)");
    return;
  }
  //  Register the Request Interceptor
  axiosInst.interceptors.request.use(async request => {
    //  Check Refresh Status
    const isRefreshing = !!(0, cookie_lock_1.peekLock)(utils_1.REFRESH_LOCK_KEY);
    if (isRefreshing) {
      await (0, cookie_lock_1.waitForUnlock)(utils_1.REFRESH_LOCK_KEY);
    }
    //  Get the Access Token
    let accessToken = (0, utils_1.getCurrentAccessToken)();
    //  Determine the Access Token Status
    let needsRefresh = false;
    //  Check Missing Token
    if (!accessToken) {
      needsRefresh = true;
    } else {
      //  Check Invalid Token
      try {
        (0, utils_1.decodeAccessToken)(accessToken);
      } catch (e) {
        needsRefresh = true;
      }
      //  Check Expired Token
      try {
        const isAccessExpired = accessToken && (0, utils_1.isTokenExpired)(accessToken);
        if (isAccessExpired) {
          needsRefresh = true;
        }
      } catch (err) {
        //  Token is Invalid
        needsRefresh = true;
      }
    }
    //  Refresh (if needed)
    //  NOTE:  If the refresh fails, we attempt the request anyways.
    if (needsRefresh) {
      await (0, utils_1.refresh)(ssoUrl, redirect, true);
      accessToken = (0, utils_1.getCurrentAccessToken)();
    }
    //  Modify Request (if needed)
    if (accessToken && callback) {
      callback(accessToken, request);
    }
    //  Continue
    return request;
  });
};
exports.registerRefreshInterceptor = registerRefreshInterceptor;